import React from 'react';
import ENUMS from '../../enums/index';
import MenuItemDetails from './modals/menuItemDetails';
import DeleteMenuItem from './modals/deleteMenuItem';
import { connect } from 'react-redux';
import * as menuItemsActions from '../../redux/menuItems/actions';
import Spin from '../../components/loading';
import EditMenuItems from './modals/insertNewMenuItem';
import ShowForPermission from '../../components/ShowForPermission';
import { numberWithCommas } from '../../utils/formatter';
import { enumHelper } from '../../utils';

class menuItemsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItemOpen: false,
      selectedTitle: '',
      editMenuItemsOpen: false,
      selectedMenuItemId: null,
      deleteMenuItemOpen: false,
      isActive: false
    };
  }

  closeMenuItemModal = () => {
    this.props
      .fetchAllMenuItems(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          menuItemOpen: false
        }));
      });
  };
  closeDeleteMenuItemOpen = () => {
    this.props
      .fetchAllMenuItems(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          deleteMenuItemOpen: false
        }));
      });
  };

  displayMenuItemModal = id => {
    this.setState({ menuItemOpen: true });
  };

  displayDeleteMenuItemOpen = id => {
    let { menuItemsList = [] } = this.props;
    let selectedMenuItemId = menuItemsList.filter(menuItem => menuItem.id == id)[0].id;
    let selectedTitle = menuItemsList.filter(menuItem => menuItem.id == id)[0].title;
    this.setState({ deleteMenuItemOpen: true, selectedMenuItemId, selectedTitle });
  };

  closeEditMenuItemsModal = () => {
    this.props
        this.setState(() => ({
          editMenuItemsOpen: false
        }));
  };

  displayEditMenuItemsModal = id => {
    let { menuItemsList = [] } = this.props;
    let selectedMenuItemId = menuItemsList.filter(menuItem => menuItem.id == id)[0].id;
    this.setState({ editMenuItemsOpen: true, selectedMenuItemId });
  };

  changeMenuItemActivity = (id, isActive) => {
    this.props.changeMenuItemActivity(id, !isActive)
    // .then(() => {
    //   this.props.fetchAllMenuItems(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`);
    // });
  };

  render() {
    let {
      menuItemsList = [],
      pageNumber,
      pageSize,
      loading,
      error,
      message,
      failed,
      statusLoading,
      statusMessage,
      statusFailed,
      statusError
    } = this.props;
    return (
      <>
        <Spin spinning={loading || statusLoading}>
          {(error || statusError) && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {(failed || statusFailed) && <div className="alert alert-danger">{message || statusMessage}</div>}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th className="text-center">{locales('tables.title')}</th>
                <th className="text-center">{locales('menu.item.image')}</th>
                <th className="text-center ">{locales('tables.menuCategoryTitle')}</th>
                <th className="text-center ">
                  {locales('tables.price')}(
                  {`${menuItemsList.length
                      ? enumHelper.convertEnumValueToTitle(ENUMS.MONEY_UNITS.list, menuItemsList[0].currency)
                      : ENUMS.MONEY_UNITS.list[0].title
                    }`}
                  )
                </th>
                <th className="text-center">{locales('tables.activated')}</th>
                <th className="text-center">{locales('tables.displayOrder')}</th>
                <th className="text-center">{locales('tables.registrar')}</th>
                <th className="text-center">{locales('tables.creationDate')}</th>
                <th className="text-center"></th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {menuItemsList.length ? (
                menuItemsList.map((menuItem, index) => (
                  <tr key={menuItem.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{menuItem.title}</td>
                    <td className='text-center'>
                      <img src={menuItem.imageUrl} className='w-25' />
                    </td>
                    <td className="text-center">{menuItem.menuCategoryTitle}</td>
                    <td className="text-center">{numberWithCommas(menuItem.price)}</td>
                    <td className="text-center">
                      <i
                        className={`${menuItem.isActive
                            ? 'fal fa-check-square text-success'
                            : 'fal fa-times-square text-danger'
                          }`}
                      />
                    </td>
                    <td className="text-center">{menuItem.displayOrder || '---'}</td>
                    <td className="text-center">{menuItem.createdFullName}</td>
                    <td className="text-center">{menuItem.createdAt}</td>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.ACTIVE_INACTIVE_MENU_ITEM}>
                      <td>
                        <button
                          className={`${menuItem.isActive ? 'btn-danger' : 'btn-success'} btn btn-sm`}
                          onClick={() => this.changeMenuItemActivity(menuItem.id, menuItem.isActive)}
                        >
                          {locales(menuItem.isActive ? 'tables.deactivate' : 'tables.activate')}
                        </button>
                      </td>
                    </ShowForPermission>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_MENU_ITEM}>
                      <td title={locales('titles.editMenuItem')}>
                        <i
                          onClick={() => this.displayEditMenuItemsModal(menuItem.id)}
                          className="text-center fa fa-pencil text-secondary pointer"
                        />
                      </td>
                    </ShowForPermission>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_MENU_ITEM}>
                      <td title={locales('titles.deleteMenuItem')}>
                        <i
                          onClick={() => this.displayDeleteMenuItemOpen(menuItem.id)}
                          className="text-center fal fa-trash text-danger pointer"
                        />
                      </td>
                    </ShowForPermission>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {this.state.editMenuItemsOpen && (
            <EditMenuItems
              pageNumber={this.props.pageNumber}
              pageSize={this.props.pageSize}
              isOpen={this.state.editMenuItemsOpen}
              closeModal={this.closeEditMenuItemsModal}
              menuItemId={this.state.selectedMenuItemId}
            />
          )}
          {this.state.menuItemOpen && (
            <MenuItemDetails isOpen={this.state.menuItemOpen} closeModal={this.closeMenuItemModal} />
          )}
          {this.state.deleteMenuItemOpen && (
            <DeleteMenuItem
              title={this.state.selectedTitle}
              isOpen={this.state.deleteMenuItemOpen}
              menuItemId={this.state.selectedMenuItemId}
              closeModal={this.closeDeleteMenuItemOpen}
            />
          )}
        </Spin>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    menuItemsList: state.menuItemsReducer.menuItemsList,
    loading: state.menuItemsReducer.menuItemLoading,
    message: state.menuItemsReducer.menuItemMessage,
    failed: state.menuItemsReducer.menuItemFailed,
    error: state.menuItemsReducer.menuItemError,

    statusLoading: state.menuItemsReducer.changeMenuItemstatusLoading,
    statusMessage: state.menuItemsReducer.changeMenuItemstatusMessage,
    statusFailed: state.menuItemsReducer.changeMenuItemstatusFailed,
    statusError: state.menuItemsReducer.changeMenuItemstatusError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllMenuItems: query => dispatch(menuItemsActions.fetchAllMenuItems(query)),
    changeMenuItemActivity: (id, isActive) => dispatch(menuItemsActions.changeMenuItemActivity(id, isActive))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(menuItemsTable);
